const SalesforceContext = ({ context }) => {
  return (
    <div className="card">
      <div className="card-header">
        <span className="card-header-icon">☁️</span>
        <h3 className="card-header-title">Salesforce Context</h3>
        {context.matchFound && (
          <span className="badge badge--green">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: "4px" }}>
              <polyline points="20 6 9 17 4 12" />
            </svg>
            Match Found
          </span>
        )}
      </div>
      <div className="card-body">
        <div className="info-row">
          <span className="info-label">Contact</span>
          <span className="info-value">{context.contact}</span>
        </div>
        <div className="info-row">
          <span className="info-label">Account</span>
          <span className="info-value">{context.accountName}</span>
        </div>
        <div className="info-row">
          <span className="info-label">Client Since</span>
          <span className="info-value">{context.clientSince}</span>
        </div>
        <div className="info-row">
          <span className="info-label">Open Cases</span>
          <span className="info-value">{context.openCases}</span>
        </div>
      </div>
    </div>
  );
};

export default SalesforceContext;
